import { render, staticRenderFns } from "./ModalAddAddress.vue?vue&type=template&id=a864f130"
import script from "./ModalAddAddress.vue?vue&type=script&lang=js"
export * from "./ModalAddAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports